import strings from "./strings";
export const privacyMessagePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultPrivacyMessage
        }
    ],
    layout: {
        selectionMode: "button"
    },
    inputData: {
        choice: {
            visibilityAfterSubmit: "block",
            list: [
                {
                    command: "privacy_ok",
                    content: [
                        {
                            type: "chat_text",
                            text: "Accetto"
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Accetto",
                                adamActions: [
                                    {
                                        code: "message.user.privacy_policy",
                                        args: ["choice", "accept"]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    command: "privacy_ko",
                    content: [
                        {
                            type: "chat_text",
                            text: "Rifiuto"
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.disable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Rifiuto",
                                adamActions: [
                                    {
                                        code: "message.user.privacy_policy",
                                        args: ["choice", "reject"]
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    }
};
export const welcomeMessagePassengersPayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultWfpWelcomeMessagePassengers
        }
    ],
    layout: {
        selectionMode: "input"
    }
};
export const welcomeMessageFocalPointPayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultWfpWelcomeMessageFocalpoints
        }
    ],
    layout: {
        selectionMode: "input"
    }
};
export const restartMessagePayload = {
    text: strings.defaultRestartMessage,
    adamActions: [{
            code: "conversation.session.restart"
        }],
};
export const timeoutMessagePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultTimeoutMessage
        }
    ],
    layout: {
        selectionMode: "button"
    },
    adamActions: [{
            code: "conversation.status.timeout"
        }],
    inputData: {
        choice: {
            visibilityAfterSubmit: "block",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    // NOTE: this command is frontend only
                    command: "command.continue_conversation",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultTimeoutContinuePreviousMessage,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultTimeoutContinuePreviousMessage,
                                adamActions: [
                                    {
                                        // NOTE: this code is frontend only
                                        code: "conversation.session.continue_conversation",
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    command: "command.restart",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultTimeoutRestartMessage,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultTimeoutRestartMessage,
                                adamActions: [
                                    {
                                        code: "conversation.session.restart",
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
};
export const dateMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "Add your start date testing",
        },
    ],
    layout: {
        selectionMode: "input",
    },
    inputData: {
        interaction: {
            type: "input_date",
            action: "input_date",
            options: {
                dateType: "date",
                minStartDate: "2026-01-01",
                maxStartDate: "2026-08-31",
            }
        }
    }
};
export const dateTimeMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "Add your start date time testing",
        },
    ],
    layout: {
        selectionMode: "input",
    },
    inputData: {
        interaction: {
            type: "input_date",
            action: "input_date",
            options: {
                dateType: "datetime",
                minStartDate: "2026-01-01T06:00:00.000Z",
                maxStartDate: "2026-06-30T22:00:00.000Z",
            }
        }
    }
};
export const timeMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "Add your time testing",
        },
    ],
    layout: {
        selectionMode: "input",
    },
    inputData: {
        interaction: {
            type: "input_date",
            action: "input_date",
            options: {
                dateType: "time",
                minStartDate: "13:00",
                maxStartDate: "22:30",
            }
        }
    }
};
export const locationMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "Inserisci l'indirizzo di riferimento location:"
        }
    ],
    inputData: {
        interaction: {
            type: "insert_location"
        }
    },
    adamActions: [],
};
export const autocompleteSingleMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "<p>Select a city</p>"
        }
    ],
    layout: {
        selectionMode: "button",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 1,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "autocomplete",
            list: [
                {
                    command: "opt_98ffeb1433273",
                    content: [
                        {
                            type: "chat_text",
                            text: "Lisbon, Portugal"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Lisbon, Portugal"
                            }
                        ]
                    }
                },
                {
                    command: "opt_023fe8f3d476a",
                    content: [
                        {
                            type: "chat_text",
                            text: "Kyoto, Japan"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Kyoto, Japan"
                            }
                        ]
                    }
                },
                {
                    command: "opt_dad17a80226808",
                    content: [
                        {
                            type: "chat_text",
                            text: "Vancouver, Canada"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Vancouver, Canada"
                            }
                        ]
                    }
                },
                {
                    command: "opt_aa6e02fb94b988",
                    content: [
                        {
                            type: "chat_text",
                            text: "Buenos Aires, Argentina"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Buenos Aires, Argentina"
                            }
                        ]
                    }
                },
                {
                    command: "opt_79ebfc57376db8",
                    content: [
                        {
                            type: "chat_text",
                            text: "Prague, Czech Republic"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Prague, Czech Republic"
                            }
                        ]
                    }
                },
                {
                    command: "opt_a1545ee5a39328",
                    content: [
                        {
                            type: "chat_text",
                            text: "Cape Town, South Africa"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Cape Town, South Africa"
                            }
                        ]
                    }
                },
                {
                    command: "opt_54160b19538bb8",
                    content: [
                        {
                            type: "chat_text",
                            text: "Auckland, New Zealand"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Auckland, New Zealand"
                            }
                        ]
                    }
                },
                {
                    command: "opt_d803f05a83be2",
                    content: [
                        {
                            type: "chat_text",
                            text: "Seoul, South Korea"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Seoul, South Korea"
                            }
                        ]
                    }
                },
                {
                    command: "opt_b0fe0679d77608",
                    content: [
                        {
                            type: "chat_text",
                            text: "Istanbul, Türkiye"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Istanbul, Türkiye"
                            }
                        ]
                    }
                },
                {
                    command: "opt_0cb7fac894717",
                    content: [
                        {
                            type: "chat_text",
                            text: "Nairobi, Kenya"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Nairobi, Kenya"
                            }
                        ]
                    }
                },
                {
                    command: "opt_538afbdf86b29",
                    content: [
                        {
                            type: "chat_text",
                            text: "Stockholm, Sweden"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Stockholm, Sweden"
                            }
                        ]
                    }
                },
                {
                    command: "opt_f883374f7c33a",
                    content: [
                        {
                            type: "chat_text",
                            text: "San Diego, USA"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "San Diego, USA"
                            }
                        ]
                    }
                },
                {
                    command: "opt_45bf35dd6d59e8",
                    content: [
                        {
                            type: "chat_text",
                            text: "Tallinn, Estonia"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Tallinn, Estonia"
                            }
                        ]
                    }
                },
                {
                    command: "opt_d6e788d7b7a99",
                    content: [
                        {
                            type: "chat_text",
                            text: "Medellín, Colombia"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Medellín, Colombia"
                            }
                        ]
                    }
                },
                {
                    command: "opt_2a4a197225dbc",
                    content: [
                        {
                            type: "chat_text",
                            text: "Dubrovnik, Croatia"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Dubrovnik, Croatia"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: []
};
export const autocompleteMultipleMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "<p>Perfect! What a nice city! Now, add your companions.</p>"
        }
    ],
    layout: {
        selectionMode: "multiple",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 10,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "inputBlock",
            submit: [
                {
                    type: "chat_text",
                    text: "Send"
                }
            ],
            list: [
                {
                    command: "opt_fb946d5fc66f6",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 1"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 1"
                            }
                        ]
                    }
                },
                {
                    command: "opt_0fda42948aed28",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 2"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 2"
                            }
                        ]
                    }
                },
                {
                    command: "opt_4a4f277c02e52",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 3"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 3"
                            }
                        ]
                    }
                },
                {
                    command: "opt_bfbeabf457d988",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 4"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 4"
                            }
                        ]
                    }
                },
                {
                    command: "opt_a69daaa6d8b9f",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 5"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 5"
                            }
                        ]
                    }
                },
                {
                    command: "opt_0d7d7228bcff8",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 6"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 6"
                            }
                        ]
                    }
                },
                {
                    command: "opt_05a49f5c88244",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 7"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 7"
                            }
                        ]
                    }
                },
                {
                    command: "opt_b518117b83f0c",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 8"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 8"
                            }
                        ]
                    }
                },
                {
                    command: "opt_28276b31377ac8",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select 9"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select 9"
                            }
                        ]
                    }
                },
                {
                    command: "opt_26c5ab77f53f5",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi select  10"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi select  10"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: []
};
export const carouselMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "&lt;p&gt;Certo! Ecco le migliori offerte che puoi attivare per il tuo viaggio in Europa. Selezionale per saperne di più&lt;/p&gt;"
        }
    ],
    layout: {
        selectionMode: "button",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 1,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    command: "opt_a614480950989",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/893fe602d649cdb7612feac8bd82b1ea.png",
                            filename: "unknown",
                            caption: "TIM in Viaggio PASS a 19,99 € /30gg"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/893fe602d649cdb7612feac8bd82b1ea.png",
                                filename: "unknown",
                                caption: "TIM in Viaggio PASS a 19,99 € /30gg"
                            }
                        ]
                    }
                },
                {
                    command: "opt_caee3a06ece6f",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/bb8d93344b48ca6c81fed0608326413e.png",
                            filename: "unknown",
                            caption: "TIM in Viaggio PASS a 13,99 € /15gg"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/bb8d93344b48ca6c81fed0608326413e.png",
                                filename: "unknown",
                                caption: "TIM in Viaggio PASS a 13,99 € /15gg"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: [],
};
export const carouselMessageSingleChoiceImage = {
    content: [
        {
            type: "chat_html",
            html: "<p>single choice image</p>"
        }
    ],
    layout: {
        selectionMode: "button",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 1,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    command: "opt_ac4b5924e9393",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/729b17725215c20c916cfcfcb6115729.png",
                            filename: "unknown"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/729b17725215c20c916cfcfcb6115729.png",
                                filename: "unknown"
                            }
                        ]
                    }
                },
                {
                    command: "opt_cd94457b1a1ce",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/2899abfe54875188f3cc60cb560cce22.png",
                            filename: "unknown"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/2899abfe54875188f3cc60cb560cce22.png",
                                filename: "unknown"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: [],
};
export const carouselMessageSingleChoiceImageText = {
    content: [
        {
            type: "chat_html",
            html: "<p>single choice image + text</p>"
        }
    ],
    layout: {
        selectionMode: "button",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 1,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    command: "opt_e0d0de2f21ac2",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/a61aa95cf1b83de2227f8cb41ec9c136.png",
                            filename: "unknown",
                            caption: "<p>single choice image + text 1</p>"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/a61aa95cf1b83de2227f8cb41ec9c136.png",
                                filename: "unknown",
                                caption: "<p>single choice image + text 1</p>"
                            }
                        ]
                    }
                },
                {
                    command: "opt_e2958bf2055b28",
                    content: [
                        {
                            type: "chat_image",
                            url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/586ced9c6e5c08eed8280ea326a5427a.png",
                            filename: "unknown",
                            caption: "<p>single choice image + text 2</p>"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_image",
                                url: "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/586ced9c6e5c08eed8280ea326a5427a.png",
                                filename: "unknown",
                                caption: "<p>single choice image + text 2</p>"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: [],
};
export const carouselMessageMultipleChoiceText = {
    content: [
        {
            type: "chat_html",
            html: "<p>multi choice text</p>"
        }
    ],
    layout: {
        selectionMode: "multiple",
        location: "in",
        orientation: "auto"
    },
    inputData: {
        choice: {
            maxSelectable: 2,
            minSelectable: 1,
            visibilityAfterSubmit: "hide",
            modeBeforeSubmit: "inputBlock",
            submit: [
                {
                    type: "chat_text",
                    text: "Send"
                }
            ],
            list: [
                {
                    command: "opt_39d344d2b8e708",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi choice text 1"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi choice text 1"
                            }
                        ]
                    }
                },
                {
                    command: "opt_a33115f27483f",
                    content: [
                        {
                            type: "chat_text",
                            text: "multi choice text 2"
                        }
                    ],
                    interaction: {
                        action: "cmd_step",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "multi choice text 2"
                            }
                        ]
                    }
                }
            ]
        }
    },
    adamActions: [],
};
export const fakeXmppCreds = {
    user: "webclient",
    token: "webclient-private-token",
    thread: "6932c570-f526-4c77-b6c1-4b241e3597db",
};
